import type { ImgHTMLAttributes } from 'react';
import { BRAND_NAME, getBrandLogoPath, type BrandLogoVariant } from '../../lib/brand';

type Props = Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'> & {
  variant?: BrandLogoVariant;
};

export function BrandLogo({ variant = 'icon', alt = BRAND_NAME, ...props }: Props) {
  return <img src={getBrandLogoPath(variant)} alt={alt} {...props} />;
}
